module.exports = __webpack_public_path__ + "media/images/web/home/index/ease_to_use-72785e435acbcc131f2891f553e8b1c3.webp";